export const GA = { ID: "UA-134733578-2" };



// WEBPACK FOOTER //
// ./src/constants.ts